module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Angle Grinder-f538ddf14dc426c72071c6f6635c1415.svg";